export default __webpack_public_path__ + "static/media/ic-full-test.47acadd2.svg";